"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _label = _interopRequireWildcard(require("./label"));

var _classnames = _interopRequireDefault(require("classnames"));

var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));

var _dropdownModule = _interopRequireDefault(require("./dropdown.module.scss"));

var _index = _interopRequireDefault(require("../icon/index"));

var _field = require("./field");

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Dropdown = function Dropdown(props) {
  var _cx, _cx2, _cx3;

  var renderOptions = function renderOptions() {
    return props.options.map(function (option, i) {
      return /*#__PURE__*/_react.default.createElement("option", (0, _extends2.default)({
        key: i
      }, option), option.label || option.value);
    });
  };

  var id = props.id || (0, _field.makeIdString)(); // eslint-disable-next-line no-negated-condition

  var valueProps = props.value !== undefined ? {
    value: props.value
  } : {};
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_dropdownModule.default.Dropdown, props.classNames.wrapper)
  }, /*#__PURE__*/_react.default.createElement(_label.default, {
    className: (0, _classnames.default)(props.classNames.label, (_cx = {}, (0, _defineProperty2.default)(_cx, _textfieldModule.default.errorLabel, props.errorMessage), (0, _defineProperty2.default)(_cx, props.classNames.labelDisabled, props.disabled), _cx)),
    for: id,
    tooltip: props.tooltip,
    size: props.size
  }, props.label), /*#__PURE__*/_react.default.createElement(_label.SubLabel, {
    className: (0, _classnames.default)(props.classNames.subLabel, (_cx2 = {}, (0, _defineProperty2.default)(_cx2, _textfieldModule.default.errorLabel, props.errorMessage), (0, _defineProperty2.default)(_cx2, _dropdownModule.default.labelDisabled, props.disabled), (0, _defineProperty2.default)(_cx2, props.classNames.labelDisabled, props.disabled), _cx2)),
    size: props.size
  }, props.subLabel), /*#__PURE__*/_react.default.createElement("span", {
    className: _dropdownModule.default.fieldIconContainer
  }, /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, valueProps, {
    disabled: props.disabled,
    name: props.name,
    id: id,
    "data-test-id": props.dataTestId,
    onChange: props.onChange,
    "aria-label": props.ariaLabel,
    onFocus: props.onFocus,
    onClick: props.onClick,
    ref: props.innerRef,
    className: (0, _classnames.default)(_dropdownModule.default.field, (_cx3 = {}, (0, _defineProperty2.default)(_cx3, _dropdownModule.default.fieldInvalid, props.errorMessage), (0, _defineProperty2.default)(_cx3, _dropdownModule.default.selectDisabled, props.disabled), (0, _defineProperty2.default)(_cx3, props.classNames.selectDisabled, props.disabled), (0, _defineProperty2.default)(_cx3, _dropdownModule.default.fieldSmall, props.size === _fieldsize.default.SMALL), (0, _defineProperty2.default)(_cx3, _dropdownModule.default.fieldDefault, props.size === _fieldsize.default.DEFAULT), _cx3), props.classNames.field)
  }), renderOptions()), /*#__PURE__*/_react.default.createElement(_index.default, {
    type: 'chevron-down',
    size: "small",
    className: _dropdownModule.default.icon,
    role: "presentation"
  })), props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
    message: props.errorMessage,
    className: props.classNames.errorMessage,
    size: props.size
  }));
};

Dropdown.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _field.fieldPropTypes), _fieldsize.fieldSizePropTypes), {}, {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  disabled: _propTypes.default.bool,
  classNames: _propTypes.default.shape({
    wrapper: _propTypes.default.string,
    label: _propTypes.default.string,
    subLabel: _propTypes.default.string,
    field: _propTypes.default.string,
    errorMessage: _propTypes.default.string,
    labelDisabled: _propTypes.default.string,
    selectDisabled: _propTypes.default.string
  })
});
Dropdown.defaultProps = _objectSpread({
  disabled: false,
  classNames: {}
}, _fieldsize.fieldSizeDefaultProps);
var _default = Dropdown;
exports.default = _default;